import React from 'react';
import '../less/list.less';
import green_card_img from '../img/list/green_card_img.png';
import premium_card_img from '../img/list/premium_card_img.png';
import yellow_card_img from '../img/list/yellow_card_img.png';
import atb_card_img from '../img/list/atb_card_img.png';
import vygoda_card_img from '../img/list/vygoda_card_img.png';
import bolt_card_img from '../img/list/bolt_card_img.png';
import kid_card_img from '../img/list/kid_card_img.png';
import eVidnovlennia_card_img from '../img/list/eVidnovlennia_card_img.png';
import ukrainians_together_card_img from '../img/list/ukrainians_together_card_img.png';
import cashback_ua_card_img from '../img/list/cashback_ua_card_img.png';
import diia_card_img from '../img/list/diia_card_img.png';
import prostor_card_img from '../img/list/prostor_card_img.webp';
import CardOrderModal from '../../../auxiliary-components/CardOrderModal';
import { Link } from 'MWC';
import SegmentedStorybook from '@abank/abank-segmented';
import { 
  URL_ATB_CARD,
  URL_PROSTOR_CARD,
  URL_BOLT_CARD, 
  URL_CASHBACK_UA_CARD,
  URL_DIIA_CARD, 
  URL_EVIDNOVLENNIA_CARD, 
  URL_GOLD_CARD, 
  URL_GREEN_CARD, 
  URL_KDV_CARD, 
  URL_KID_CARD, 
  URL_KUN_CARD, 
  URL_PREMIUM_CARD, 
  URL_PROJECT_SUPPORT_CARD, 
  URL_UKRAININANS_TOGETHER_CARD, 
  URL_VYGODA_CARD, 
  URL_YELLOW_CARD 
} from '../variables';
import activeCardsConfig from "./enums/list_active_cards.json"
import archiveCardsConfig from "./enums/list_archive_cards.json"
import ProductList from '../../../auxiliary-components/shared/ProductList';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const page = 'cards-new-list'
  const tabs = [{tab: 'all', name: this.l10n('CARDS_NEW_TABS_TITLE_01')},
        {tab: 'credit', name: this.l10n('CARDS_NEW_TABS_TITLE_02')},
        {tab: 'debit', name: this.l10n('CARDS_NEW_TABS_TITLE_03')},
        {tab: 'partner', name: this.l10n('CARDS_NEW_TABS_TITLE_04')},
        {tab: 'gov', name: this.l10n('CARDS_NEW_TABS_TITLE_05')}];

  const images = {
    green_card_img,
    premium_card_img,
    yellow_card_img,
    atb_card_img,
    vygoda_card_img,
    bolt_card_img,
    kid_card_img,
    eVidnovlennia_card_img,
    ukrainians_together_card_img,
    cashback_ua_card_img,
    diia_card_img,
    prostor_card_img
  };

  const urls = {
    URL_ATB_CARD,
    URL_PROSTOR_CARD,
    URL_BOLT_CARD,
    URL_CASHBACK_UA_CARD,
    URL_DIIA_CARD,
    URL_EVIDNOVLENNIA_CARD,
    URL_GOLD_CARD,
    URL_GREEN_CARD,
    URL_KDV_CARD,
    URL_KID_CARD,
    URL_KUN_CARD,
    URL_PREMIUM_CARD,
    URL_PROJECT_SUPPORT_CARD,
    URL_UKRAININANS_TOGETHER_CARD,
    URL_VYGODA_CARD,
    URL_YELLOW_CARD
  };

  const activeCardsData = activeCardsConfig.map(item => ({
    ...item,
    image: images[item.image],
    detailsLink: urls[item.detailsLink]
  }));

  const archiveCardsData = archiveCardsConfig.map(item => ({
    ...item,
    link: urls[item.link]
  }));

  return (
    <div className="cards-new">
      <div className="cards-new__active-cards">
        <div className="container">
          <h1 className="cards-new__title">{this.l10n('CARDS_NEW_TITLE')}</h1>
          <SegmentedStorybook 
            collapsed={this.state.isSegmentedCollapsed} 
            tabs={tabs} 
            tab={this.state.tab} 
            toggle={this.toggleTab} 
            leadIcon={false}
          >
            {tabs.map((t, index) => {
              const filteredCards =
                t.tab === 'all'
                  ? activeCardsData
                  : activeCardsData.filter(card => card.tabs.includes(t.tab));

              return (
                <div key={index} className="cards-new__list">
                  <div className="cards-new__items">
                    {filteredCards.map(card => (
                      <div key={card.id} className="cards-new__item item-cards-new">
                        <div className="item-cards-new__left">
                          <div className="item-cards-new__top">
                            <div className="item-cards-new__chips">
                              {card.chips.map(chip => (
                                <div key={chip} className="item-cards-new__chip">{this.l10n(chip)}</div>
                              ))}
                            </div>
                            {this.state.isMobile && (
                              <img src={card.image} alt={`${card.id} card image`} className="item-cards-new__image" />
                            )}
                            <h2 className="item-cards-new__title">{this.l10n(card.title)}</h2>
                            <div className="item-cards-new__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(this.l10n(card.text))}}></div>
                          </div>
                          <div className="item-cards-new__btns">
                            <button
                              className="item-cards-new__btn item-cards-new__btn_order"
                              onClick={() => this.toggleModal(card.id)}
                              id={`${page} ${card.id}-order`}
                            >
                              {this.l10n("CARDS_NEW_BTN_ORDER")}
                            </button>
                            <Link 
                              href={card.detailsLink} 
                              onClick={e => this.navigate(card.detailsLink, e)} 
                              className="item-cards-new__btn item-cards-new__btn_details"
                              id={`${page} ${card.id}-details`}
                            >
                              {this.l10n("CARDS_NEW_BTN_DETAILS")}
                            </Link>
                          </div>
                        <div className="item-cards-new__benefits">
                          {card.benefits.map((benefit, idx) => (
                            <div key={idx} className="item-cards-new__benefit benefit-item-list-new">
                              <div className="benefit-item-list-new__title">{this.l10n(benefit.title)}</div>
                              <div className="benefit-item-list-new__text">{this.l10n(benefit.text)}</div>
                            </div>
                          ))}
                        </div>
                        </div>
                        {!this.state.isMobile && (
                          <img src={card.image} alt={`${card.id} card image`} className="item-cards-new__image" />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </SegmentedStorybook>
        </div>
      </div>
      {this.state.tab === "all" && (
        <ProductList
          section="archive"
          title="CARDS_NEW_ARCHIVE_TITLE"
          titleTag="h2"
          itemTitleTag="h3"
          items={archiveCardsData}
          page={page}
        />
      )}
      {this.state.showModal ? 
        <CardOrderModal closeModal={this.toggleModal} product={this.state.cardType} cardList={true} isOpen={this.state.showModal}/> : ''
      }
    </div>
  );
}
